import { SearchViewModel } from '@/types/api'

export type SearchAPIResponse =
    | {
          isSuccess: true
          data: SearchViewModel
      }
    | { isSuccess: false; errors: unknown }

export enum SuggestionType {
    Popular = 'popular',
    Categories = 'categories',
    Brands = 'brands',
    Products = 'products',
    History = 'history',
}
